<template>
  <svg
    v-if="type === 'square'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M16.6666 19.3337H3.33329C1.86053 19.3337 0.666626 18.1398 0.666626 16.667V3.33366C0.666626 1.8609 1.86053 0.666992 3.33329 0.666992H16.6666C18.1394 0.666992 19.3333 1.8609 19.3333 3.33366V16.667C19.3333 18.1398 18.1394 19.3337 16.6666 19.3337ZM3.33329 3.33366V16.667H16.6666V3.33366H3.33329ZM8.66663 14.483L5.06663 10.9537L6.93329 9.04699L8.66663 10.7417L13.0666 6.38566L14.9333 8.28166L8.66663 14.4817V14.483Z"
      :fill="fill"
    />
  </svg>

  <svg
    v-else-if="type === 'circle'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 20C4.47967 19.994 0.00606237 15.5204 0 10V9.80002C0.109931 4.30455 4.63459 -0.0720257 10.1307 0.000898217C15.6268 0.0738221 20.0337 4.5689 19.9978 10.0654C19.9619 15.5618 15.4966 19.9989 10 20ZM5.41 9.59002L4 11L8 15L16 7.00002L14.59 5.58002L8 12.17L5.41 9.59002Z"
      :fill="fill"
    />
  </svg>

  <svg
    v-else-if="type === 'circle-o'"
    width="20"
    height="20"
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C19.9939 15.5203 15.5203 19.9939 10 20ZM9.984 18H10C14.4167 17.9956 17.9942 14.4127 17.992 9.996C17.9898 5.57929 14.4087 2 9.992 2C5.57528 2 1.99421 5.57929 1.992 9.996C1.98979 14.4127 5.56729 17.9956 9.984 18ZM8 15L4 11L5.41 9.59L8 12.17L14.59 5.58L16 7L8 15Z"
      :fill="fill"
    />
  </svg>

  <svg
    v-else-if="type === 'square-full'"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M14.2857 16H1.71429C0.7675 16 0 15.2325 0 14.2857V1.71429C0 0.7675 0.7675 0 1.71429 0H14.2857C15.2325 0 16 0.7675 16 1.71429V14.2857C16 15.2325 15.2325 16 14.2857 16ZM6.9755 12.4979L13.5469 5.92646C13.7701 5.70332 13.7701 5.3415 13.5469 5.11836L12.7388 4.31025C12.5157 4.08711 12.1539 4.08707 11.9307 4.31025L6.57143 9.66946L4.06932 7.16736C3.84618 6.94421 3.48436 6.94421 3.26118 7.16736L2.45307 7.97546C2.22993 8.19861 2.22993 8.56043 2.45307 8.78357L6.16736 12.4979C6.39054 12.7211 6.75232 12.7211 6.9755 12.4979Z"
      fill="#0D7A12"
    />
  </svg>
</template>

<script setup>
defineOptions({
  name: 'IconsCheckedBox'
})

defineProps({
  type: {
    type: String,
    default: 'square'
  },

  fill: {
    type: String,
    default: '#0D7A12'
  }
})
</script>
